/** Turns imagetools `as=meta` variants into `<img>` props, with the middle width as the fallback `src`. */
export function responsiveImage(variants: { src: string; width: number }[]) {
  const byWidth = [...variants].sort((a, b) => a.width - b.width);
  return {
    src: byWidth[Math.floor(byWidth.length / 2)].src,
    srcSet: byWidth
      .map((variant) => `${variant.src} ${variant.width}w`)
      .join(", "),
  };
}

export type ResponsiveImage = ReturnType<typeof responsiveImage>;
